import React, { PropsWithChildren } from 'react'

import { StructuredTextLeaf } from '@app/lib/inputs/RichEditor/types'

export type LeafProps = {
  attributes: Record<string, any>
  leaf: StructuredTextLeaf
}

export const Leaf = ({ attributes, children, leaf }: PropsWithChildren<LeafProps>) => {
  if (leaf.Bold) {
    children = <strong>{children}</strong>
  }

  if (leaf.Italic) {
    children = <em>{children}</em>
  }

  if (leaf.Underline) {
    children = <u>{children}</u>
  }

  return <span {...attributes}>{children}</span>
}
